import { render, staticRenderFns } from "./SurveyItemTextarea.vue?vue&type=template&id=044e0e37&scoped=true&"
import script from "./SurveyItemTextarea.vue?vue&type=script&lang=js&"
export * from "./SurveyItemTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044e0e37",
  null
  
)

export default component.exports